function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff"
    },
    fillRule: "evenodd",
    d: "M.001 5.999h6.012L6 0h1.999v5.999h6.002v2H7.999V14H6V7.999H.001v-2z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoMore);
export default __webpack_public_path__ + "static/media/ico-more.36f86bcf33902c2ee89bb020b8f03e0f.svg";
export { ForwardRef as ReactComponent };